import React from "react";

type InfoButtonProps = {
  onClick: () => void;
};

const InfoButton: React.FC<InfoButtonProps> = ({ onClick }) => (
  <span
    className="info-icon"
    onClick={(e) => {
      e.stopPropagation();
      onClick();
    }}
  >
    ?
  </span>
);

export default InfoButton;
